// ---------- Font Scaler ----------
class FontScaler {
    constructor() {
        this.currentScale = 100;
        this.buttons = document.querySelectorAll('.font-scale-btn');
        this.announcer = null;
        this.init();
    }

    init() {
        const saved = safeStorage.get('fontScale');
        const system = getSystemFontScale();
        const startScale = saved ? parseInt(saved) : system;

        this.setScale(startScale, false);

        this.buttons.forEach(btn => {
            btn.addEventListener('click', e =>
                this.setScale(parseInt(e.currentTarget.dataset.scale))
            );
            btn.addEventListener('keydown', e => this.handleKeydown(e));
        });

        this.announcer = createAnnouncer('font-scale-announcer');
    }

    setScale(scale, announce = true) {
        if (scale === this.currentScale) return;

        const html = document.documentElement;
        html.classList.remove('scale-125', 'scale-150');
        if (scale !== 100) html.classList.add(`scale-${scale}`);

        this.updateButtonStates(scale);
        safeStorage.set('fontScale', scale);
        this.currentScale = scale;

        if (announce && this.announcer) {
            this.announcer.textContent = `Tekstgrootte aangepast naar ${scale}%`;
        }
    }

    updateButtonStates(activeScale) {
        this.buttons.forEach(btn =>
            btn.setAttribute(
                'aria-pressed',
                (parseInt(btn.dataset.scale) === activeScale).toString()
            )
        );
    }

    handleKeydown(e) {
        const keys = { ArrowLeft: -1, ArrowUp: -1, ArrowRight: 1, ArrowDown: 1, Home: 'first', End: 'last' };
        if (!(e.key in keys)) return;

        e.preventDefault();
        const index = [...this.buttons].indexOf(e.currentTarget);
        let target;

        if (keys[e.key] === 'first') target = 0;
        else if (keys[e.key] === 'last') target = this.buttons.length - 1;
        else {
            target = index + keys[e.key];
            if (target < 0) target = this.buttons.length - 1;
            if (target >= this.buttons.length) target = 0;
        }
        this.buttons[target].focus();
    }
}